module.exports = __webpack_public_path__ + "public/StoreIcon/DeleteIcon.png?885323ef";